export type Review = {
  name: string;
  route: string;
  date: string;
  source: string;
  sourceUrl: string;
  text: string;
};

/**
 * Verified customer reviews published on TransportReviews.com for
 * Enterprise Auto Transport (Rena Anders, owner). Quoted as written.
 */
export const REAL_REVIEWS: Review[] = [
  {
    name: "Arun Pradhan",
    route: "SF Bay Area, CA → Northern Virginia",
    date: "June 3, 2024",
    source: "TransportReviews",
    sourceUrl: "https://www.transportreviews.com/Company/Enterprise-Auto-Transport/Reviews/476216/",
    text: "I transported the car from SF Bay Area to Northern Virginia. Rena was very well versed and explained me the whole process including the comission and what can go wrong and right. She understands the car transportaion industry very well and very transparent about the process. My car was delivered on time without issus and i would definetly recommend Enterprise Transprt and Rena to anyone who need Car transportation service",
  },
  {
    name: "John Cain",
    route: "Coeur d'Alene, ID → Huntington Beach, CA",
    date: "December 7, 2023",
    source: "TransportReviews",
    sourceUrl: "https://www.transportreviews.com/Company/Enterprise-Auto-Transport/Reviews/468938/",
    text: "I can't say enough positive remarks about the service Rena provided transporting my vehicle from Idaho to California. This was my first experience with this type of service and it could not have went any better. Rena kept us informed from the first call and throughout the entire process and the cost was more than fair compared to the other quotes I received. I would recommend Rena and Enterprise Auto Transport to anyone that wants reliable, honest and trustworthy people handling their auto transport at a fair price.",
  },
  {
    name: "Micheal Crawley",
    route: "Little Rock, AR → Westernport, MD",
    date: "April 12, 2023",
    source: "TransportReviews",
    sourceUrl: "https://www.transportreviews.com/Company/Enterprise-Auto-Transport/Reviews/453951/",
    text: "I had an amazing experience when it came to shipping my vehicle. It was my first time ever shipping a vehicle, or rather had one shipped to me, and Rena went above and beyond to make sure that I didn't have to do anything. The deliver was on time and the carriers that she uses are equally professional. I will definitely use Enterprise Auto Transport when I purchase another vehicle and I will recommend them to everyone.",
  },
  {
    name: "Brian Rush",
    route: "Florida → Oklahoma",
    date: "September 21, 2022",
    source: "TransportReviews",
    sourceUrl: "https://www.transportreviews.com/Company/Enterprise-Auto-Transport/Reviews/441461/",
    text: "Rena has helped me transport numerous cars over the years (yes, I'm a real person and no one is paying for this review). Every time she has been attentive and quick to respond. She only uses the best drivers/carriers and always gives me options for cost and speed. I recommend her HIGHLY!! She is my first and last call when I need to ship a car. I wont even consider another shipper. Thanks Rena!!!",
  },
  {
    name: "Francis King",
    route: "California → Florida",
    date: "September 17, 2022",
    source: "TransportReviews",
    sourceUrl: "https://www.transportreviews.com/Company/Enterprise-Auto-Transport/Reviews/441191/",
    text: "I have shipped my car with many companies before but this company really stood out for their honesty and I appreciate the education on how their company works. They are more of an advisor and give you information on how much the bid should be to the carriers to get it accepted. I like the idea that I was put in the drivers seat for my own bid and had full control over it. Thank you for the great work!! 10 stars for the carrier too!",
  },
  {
    name: "Carol R.",
    route: "Florida → Minnesota (twice a year, 3 years)",
    date: "April 14, 2022",
    source: "TransportReviews",
    sourceUrl: "https://www.transportreviews.com/Company/Enterprise-Auto-Transport/Reviews/431100/",
    text: '"Rena" at Enterprise has successfully been my auto transport person twice a year for 3 years. I have always been pleased with the drivers and they have taken excellent care of my car. You can choose one of the big companies, or have the personal attention on one person from beginning to end. Rena has been in the business for a long time and personally knows a number of the transports and their drivers. She is great at picking the right one for the best trip and provides safe, and consistent service. I trust her advice and know she will do her best to give you the best service.',
  },
  {
    name: "Vito Romano",
    route: "Cape Coral, FL → Bethpage, NY",
    date: "December 20, 2021",
    source: "TransportReviews",
    sourceUrl: "https://www.transportreviews.com/Company/Enterprise-Auto-Transport/Reviews/424300/",
    text: "After entering a request for auto transport from Florida to NY, I was bombarded with e-mails, text and phone calls from many brokers. I recieved one e-mail from Rena fromn Enterprise Auto Transport which I replied to because her e-mail had information that made me want to learn more. She called me as I requested and clearly explained the transport industry to me. I was sold on her honesty. My car was picked up and delivered exactly as Rena explained. No issues and i would highly recomend Rena and Enterprise for your car transport needs.",
  },
  {
    name: "Vinicius Lucena",
    route: "Gardena, CA → Nashville, TN",
    date: "November 10, 2021",
    source: "TransportReviews",
    sourceUrl: "https://www.transportreviews.com/Company/Enterprise-Auto-Transport/Reviews/421406/",
    text: "I spent over an hour on the phone in a free consultation where I was explained everything about how that industry works to feel more confident and secure, Rena was very realistic to me, I really appreciate the great job that she has done! Thank you!",
  },
  {
    name: "TOH",
    route: "New Jersey → Tennessee",
    date: "September 27, 2021",
    source: "TransportReviews",
    sourceUrl: "https://www.transportreviews.com/Company/Enterprise-Auto-Transport/Reviews/417866/",
    text: "This business was recommended by my mover, Rena contacted me right after I requested online quote. It was my first time to ship my car. She explained details and steps of car transportation. She was responsive and always there to answer to my questions and concerns.",
  },
  {
    name: "Shay",
    route: "Minnesota → Texas",
    date: "September 21, 2021",
    source: "TransportReviews",
    sourceUrl: "https://www.transportreviews.com/Company/Enterprise-Auto-Transport/Reviews/417400/",
    text: "I had a great experience with enterprise auto transport. Rena was so helpful and honest about the whole process. She gave me the best price and had great insight and knowledge on how the trucking industry/ dispatching worked, great instincts, and got my car picked up after working with another carrier and broker who was essentially dishonest. My new driver was excellent and kept in contact with me the entire time. Worth every cent.",
  },
  {
    name: "Ryan",
    route: "Open transport",
    date: "February 28, 2022",
    source: "TransportReviews",
    sourceUrl: "https://www.transportreviews.com/Company/Enterprise-Auto-Transport/Reviews/428516/",
    text: "Rena goes above and beyond for customer service. Answered all my questions and made sure I was understanding and comfortable with the process. She screens and uses only top notch carriers.",
  },
  {
    name: "Genevieve Hall",
    route: "Florida → Washington",
    date: "March 15, 2022",
    source: "TransportReviews",
    sourceUrl: "https://www.transportreviews.com/Company/Enterprise-Auto-Transport/Reviews/429437/",
    text: "Enterprise Auto Service provided a very reliable service, got our vehicle from Florida to Washington with no problems and on time. I would recommend without hesitation.",
  },
  {
    name: "Liz",
    route: "Las Vegas, NV → Cleveland, OH",
    date: "November 28, 2022",
    source: "TransportReviews",
    sourceUrl: "https://www.transportreviews.com/Company/Enterprise-Auto-Transport/Reviews/446010/",
    text: "A really great experience. Rena was very informative and helpful. Worked within our means for dates, and cost was reasonable. Would do it again! Recommended!!",
  },
  {
    name: "Nicole",
    route: "Open transport",
    date: "September 28, 2022",
    source: "TransportReviews",
    sourceUrl: "https://www.transportreviews.com/Company/Enterprise-Auto-Transport/Reviews/442039/",
    text: "Rena was great, explained the entire process so I understood perfectly. Provided an outline of what to do/how the process works and had my car shipped within the week.",
  },
  {
    name: "Sam Chidester",
    route: "First-time shipper",
    date: "December 15, 2021",
    source: "TransportReviews",
    sourceUrl: "https://www.transportreviews.com/Company/Enterprise-Auto-Transport/Reviews/423993/",
    text: "Rina was amazing. She really made sure I was taken care of and feeling secure. So awesome my first experience and it was great. She was in constant contact with me.",
  },
];

export const FEATURED_REVIEWS = REAL_REVIEWS.slice(0, 3);
